const DropdownToggle = ({ title, name }) => (
  <a
    className="btn btn-white text-black dropdown-toggle d-block px-3"
    href="app/javascript/CarsSearch/components/SearchFilters/DropdownToggle#"
    role="button"
    id={`dropdown-filter-${name}`}
    data-bs-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    data-bs-auto-close="outside"
  >
    {title}
  </a>
)

export default DropdownToggle
